import { render, staticRenderFns } from "./PageBase.vue?vue&type=template&id=0f3117ad"
import script from "./PageBase.vue?vue&type=script&lang=js"
export * from "./PageBase.vue?vue&type=script&lang=js"
import style0 from "./PageBase.vue?vue&type=style&index=0&id=0f3117ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports